"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _Caption = _interopRequireDefault(require("./Caption")); // import app components


var Input = function Input(props) {
  var value = props.value,
      name = props.name,
      type = props.type,
      onChange = props.onChange,
      placeholder = props.placeholder,
      rows = props.rows,
      label = props.label,
      instructions = props.instructions,
      className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["value", "name", "type", "onChange", "placeholder", "rows", "label", "instructions", "className"]);
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, label && /*#__PURE__*/_react.default.createElement(_Caption.default, {
    className: className,
    children: label
  }), instructions && /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: "secondary",
    children: instructions
  }), !!rows ? /*#__PURE__*/_react.default.createElement(_antd.Input.TextArea, (0, _extends2.default)({
    value: value,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    rows: rows,
    className: className
  }, rest)) : type === 'password' ? /*#__PURE__*/_react.default.createElement(_antd.Input.Password, (0, _extends2.default)({
    value: value,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    className: className,
    type: type,
    autoComplete: "off",
    iconRender: function iconRender(visible) {
      return visible ? /*#__PURE__*/_react.default.createElement(_icons.EyeTwoTone, null) : /*#__PURE__*/_react.default.createElement(_icons.EyeInvisibleOutlined, null);
    }
  }, rest)) : /*#__PURE__*/_react.default.createElement(_antd.Input, (0, _extends2.default)({
    value: value,
    name: name,
    type: type,
    onChange: onChange,
    placeholder: placeholder,
    className: className
  }, rest)));
};

var _default = Input;
exports.default = _default;